module.exports = __webpack_public_path__ + "img/item04.783d03ee.png";